import React, { Component } from 'react';
import "./Map.scss";
import mapImage from '../../static/images/map.svg'
import RenderPins from '../RenderPins/RenderPins';
import Popup from '../Popup/Popup';
import DragScroll from '../../static/DragScroll-Sabag';
import { scrollToElement } from '../../static/scrollAnimation'
import "../RenderPins/RenderPins.scss";
import pinsJson from "../../static/api/data.json";
import { pins } from "../App/filters"

var zoomAmount = 300;

const promoter = 300;
var maxSize = 2358;
const timeOutZoom = 600;
var minWidth, maxWidth;

Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

export default class Map extends Component {
  constructor() {
    super();
    this.state = {
      itemPopup: null,
      isBusy: false,
      currentFilter: "",
      mapWidth: minWidth,
      rendered: false
    }
  }
  componentWillReceiveProps(newProps) {
    if (newProps.currentFilter != "") {
      this.setState({
        pins: this.renderPins()
      }, () => {
        this.setState({
          pins: this.renderPins()
        })
      });
      if (newProps.currentFilter != this.state.currentFilter) {
        this.setState({
          currentFilter: newProps.currentFilter,
          itemPopup: null
        })
      }
    }
  }
  animateZoom = (e, type, to) => {
    let start = e[type],
      change = to - start,
      currentTime = 0,
      duration = 500,
      increment = 10;

    let animateScroll = () => {
      currentTime += increment;
      let val = Math.easeInOutQuad(currentTime, start, change, duration);
      e[type] = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };

    animateScroll();
  }
  // centerMap = () => {
  //   // this.map_wrap.scrollLeft = this.map_wrap.scrollWidth / 2 - 0.60 * this.map_wrap.clientWidth;
  //   // this.map_wrap.scrollTop = this.map_wrap.scrollHeight / 2 - 0.80 * this.map_wrap.clientHeight;
  //   this.animateZoom(this.map_wrap, "scrollLeft", this.map_wrap.scrollWidth / 2 - 0.60 * this.map_wrap.clientWidth);
  //   this.animateZoom(this.map_wrap, "scrollTop", this.map_wrap.scrollHeight / 2 - 0.80 * this.map_wrap.clientHeight);
  // }

  centerMap(width) {
    setTimeout(() => {
      scrollToElement("map-container", "map_wrap_in", 600, width)
    }, 0);
  }

  zoomIn = () => {
    let promo = this.state.mapWidth + promoter;
    if (promo <= maxWidth) {
    this.centerMap(promo);
      this.setState(prevState => ({
        mapWidth: promo <= maxWidth ? promo : maxWidth
      }));
    }
  }
  zoomOut = () => {
    let promo = this.state.mapWidth - promoter;
    if (promo >= minWidth) {
      this.centerMap(promo);
      this.setState({
        mapWidth: promo >= minWidth ? promo : minWidth
      });
    }
  }

  // zoomIn = () => {
  //   let $map = this.mobileMap;
  //   let width = $map.attributes["width"] ? parseInt($map.attributes["width"].value) : $map.width;
  //   if (width + zoomAmount <= maxSize) {
  //     try {
  //       $map.setAttribute("style", `width: ${parseInt(width + zoomAmount, 10)}px`);
  //     } catch (e) {
  //       $map.setAttribute("style", `width: ${parseInt(width + zoomAmount, 10)}px`);
  //     }
  //     this.mapWrapper.setAttribute("style", `width: ${parseInt(width + zoomAmount, 10)}px`);
  //   }

  //   window.setTimeout(this.centerMap, timeOutZoom);
  // }
  // zoomOut = () => {
  //   let $map = this.mobileMap;
  //   let width = $map.attributes["width"] ? parseInt($map.attributes["width"].value) : $map.width;
  //   if (width - zoomAmount < 1195) {
  //     return;
  //   }
  //   if (width - zoomAmount >= 640) {
  //     try {
  //       $map.setAttribute("style", `width: ${parseInt(width - zoomAmount, 10)}px`);
  //     } catch (e) {
  //       $map.setAttribute("style", `width: ${parseInt(width - zoomAmount, 10)}px`);
  //     }
  //     this.mapWrapper.setAttribute("style", `width: ${parseInt(width - zoomAmount, 10)}px`);
  //   }

  //   window.setTimeout(this.centerMap, timeOutZoom);
  // }
  handleTouchStart = () => {
    document.body.cancelable = true;
    document.body.addEventListener('touchmove', this.disableScroll, { passive: false });
}
handleTouchEnd = () => {
    document.body.removeEventListener('touchmove', this.disableScroll, { passive: false });
}
disableScroll = (e) => {
    // if (e.cancelable)
    e.preventDefault();
}
  componentDidMount() {
    this.setState({
      pins: this.renderPins()
    })
    window.setTimeout(this.centerMap, 250);
    setTimeout(() => {
      this.centerMap();
      var elem = document.getElementsByClassName("map-container")[0];
      if (elem) {
        var imageHeight = document.getElementsByClassName("map")[0].offsetHeight;
        elem.scrollTop = 0;
      }
      minWidth = parseInt(window.getComputedStyle(document.getElementsByClassName("image-wrap")[0], null).getPropertyValue("min-width").replace("px", ""));
      maxWidth = parseInt(window.getComputedStyle(document.getElementsByClassName("image-wrap")[0], null).getPropertyValue("max-width").replace("px", ""));
      this.setState({
        mapWidth: minWidth
      });
    }, 300)

  }
  togglePopup = item => this.setState({
    itemPopup: item
  })

  renderPins = () => {
    return pinsJson.map((item, index) => <div
      onClick={() => {
        this.togglePopup({
          ...item,
          index: index
        });
      }}
      key={index} className={`pinned ${this.props.currentFilter == "" ? "show" : item.Filter.indexOf(this.props.currentFilter) > -1 ? "show" : "hide"} pin-${index}`}>
      <div className={`_pin pt-${this.props.currentFilter != "" ? pins.filter(key => key.filter == this.props.currentFilter)[0].image : (() => {
        let firstFilter = item.Filter.split(",");
        let random = Math.floor((Math.random() * firstFilter.length) + 0);
        return 1;
        return pins.filter(key => key.filter.indexOf(firstFilter[random]))[random].image
      })()}`}></div>
    </div >)
  }



  render() {
    return (
      <section className="section section-map">
        <div className="container">
          <div ref={map_wrap => this.map_wrap = map_wrap} className="map_wrap_out dragscroll">
            <DragScroll className="map-container">
              <div className="image-wrap" id="map_wrap_in" style={{ width: `${this.state.mapWidth}px` }} onClick={(event) => {
                if (event.target.className.indexOf("_pin") == -1) {
                  this.togglePopup(null);
                }
              }}>
                <img onTouchMove={this.handleTouchStart} onTouchEnd={this.handleTouchEnd} onTouchStart={this.handleTouchStart}
                  ref={mobileMap => this.mobileMap = mobileMap} className="map" id="map_mobile" src={mapImage} />
                <div className="markers-container" ref={mapWrapper => this.mapWrapper = mapWrapper} >
                  {/* <RenderPins
                    togglePopup={this.togglePopup}
                    currentFilter={this.props.currentFilter}
                    togglePopup={this.togglePopup}
                  /> */}
                  {/* {this.renderPins()} */}
                  {this.state.pins}
                </div>
              </div>
            </DragScroll>
          </div>
          <div className="zoom-container">
            <div className="zoom">
              <div className="plus" onClick={this.zoomIn}></div>
              <div className="minus" onClick={this.zoomOut}></div>
            </div>
          </div>
        </div>
        <Popup
          togglePopup={this.togglePopup}
          itemPopup={this.state.itemPopup}
        />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Map/Map.jsx